/** Folds a batch of IntersectionObserver entries into `intersecting`, keeping only
 * the message anchors currently in the viewport (mutates the passed map in place). */
export function updateIntersectingMap(
    entries: IntersectionObserverEntry[],
    intersecting: Map<string, IntersectionObserverEntry>,
): void {
    for (const entry of entries) {
        const id = entry.target.getAttribute("data-msg-anchor");
        if (!id) continue;
        if (entry.isIntersecting) {
            intersecting.set(id, entry);
        } else {
            intersecting.delete(id);
        }
    }
}

/** Topmost visible message anchor (smallest `boundingClientRect.top`) — the
 * reading-position dot. Returns null when nothing is currently intersecting. */
export function getTopmostVisibleId(intersecting: Map<string, IntersectionObserverEntry>): string | null {
    let bestId: string | null = null;
    let bestTop = Infinity;
    for (const [id, entry] of intersecting) {
        if (entry.boundingClientRect.top < bestTop) {
            bestTop = entry.boundingClientRect.top;
            bestId = id;
        }
    }
    return bestId;
}

/** Even vertical distribution of nav dots (percent). A single item sits centred. */
export function calculateItemPosition(index: number, total: number): number {
    return total <= 1 ? 50 : (index / (total - 1)) * 100;
}

export function lastMessageId(messageIds: readonly string[]): string | null {
    return messageIds[messageIds.length - 1] ?? null;
}
